import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}


// const getUser = async():Promise<{name:string; age:number}>=>({
// name:"Valeriy", age:25
// })

// как полусить из этой функции тип возвращаемого значения?

// type User = Awaited<ReturnType<typeof getUser>>

